module.exports = __webpack_public_path__ + "static/media/min-APPM-card.11e9c61c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Experience/min-APPM-card.jpg
// module id = 396
// module chunks = 0